@if (reports$ | async; as reports) {
  <div class="nt-container">
    @if ((limitReached$ | async) === true) {
      <div class="nt-container__row">
        <section class="nt-container__col">
          <mat-icon class="nt-icon nt-icon--warning">warning</mat-icon>
        </section>
        <section class="nt-container__col">
          <p>{{ 'export-snackbar.limit' | transloco }}</p>
          <p>{{ 'export-snackbar.clear-queue' | transloco }}</p>
        </section>
        <section class="nt-container__col">
          <button (click)="close(null, reports.length)" mat-icon-button>
            <mat-icon>close</mat-icon>
          </button>
        </section>
      </div>
    }
    @for (report of reports; track report) {
      <div class="nt-container__row">
        <section class="nt-container__col">
          @if (preparing(report)) {
            <mat-spinner class="nt-icon nt-icon--preparing nt-spinner" diameter="18"></mat-spinner>
          }
          @if (ready(report)) {
            <mat-icon class="nt-icon nt-icon--ready">check_circle</mat-icon>
          }
          @if (error(report)) {
            <mat-icon class="nt-icon nt-icon--warning">warning</mat-icon>
          }
        </section>
        <section class="nt-container__col">
          @if (preparing(report)) {
            <p>{{ getSnackbarStatus(report.exportStatus) | async }}</p>
          }
          @if (ready(report)) {
            <p>{{ getSnackbarStatus(report.exportStatus) | async }}</p>
          }
          @if (error(report)) {
            <p>{{ getSnackbarStatus(report.exportStatus) | async }}</p>
          }
          <p>{{ report.name }}</p>
        </section>
        <section class="nt-container__col">
          @if (!downloadedReports.includes(report.id)) {
            <button mat-button class="nt-btn" (click)="download(report, reports.length)" [disabled]="!ready(report)">
              {{ 'export-snackbar.download' | transloco }}
            </button>
          }
          @if (downloadedReports.includes(report.id)) {
            <mat-spinner class="nt-spinner" diameter="18"></mat-spinner>
          }
        </section>
        <section class="nt-container__col">
          <button (click)="close(report, reports.length)" mat-icon-button>
            <mat-icon>close</mat-icon>
          </button>
        </section>
      </div>
    }
  </div>
}
